import { PayableStatus } from "@wingspanhq/wingspan-api-sdk";
import { getOverdueBoundary } from "../utils/getOverdueBoundary";

type SelectorIsPayableOverdueParams = {
  status?: PayableStatus;
  dueDate?: Date;
  now?: Date;
};

/**
 * An opened payable is overdue once the calendar day has moved past its due
 * date. A payable due today is not overdue — see `getOverdueBoundary` for why
 * the comparison is against a day rather than the current instant.
 */
export const selectorIsPayableOverdue = ({
  status,
  dueDate,
  now
}: SelectorIsPayableOverdueParams): boolean =>
  status === PayableStatus.OPENED &&
  !!dueDate &&
  dueDate < getOverdueBoundary(now);
